import React from "react";
import InputField from "../../FormFields/InputField";

const MessageA14 = (props) => {
  return (
    <div style={{ width: "90%", margin: "0 auto" }}>
      <InputField {...props} />
    </div>
  );
};

export default MessageA14;
